export default __webpack_public_path__ + "static/media/theme-switch-light.25eb78db.svg";